var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 8.75V15.6944C15.625 15.8418 15.5665 15.9831 15.4623 16.0873C15.3581 16.1915 15.2168 16.25 15.0694 16.25H3.125C2.95924 16.25 2.80027 16.1842 2.68306 16.0669C2.56585 15.9497 2.5 15.7908 2.5 15.625V6.875C2.5 6.70924 2.56585 6.55027 2.68306 6.43306C2.80027 6.31585 2.95924 6.25 3.125 6.25H6.66667C6.8019 6.25 6.93348 6.29386 7.04167 6.375L9.20833 8C9.31652 8.08114 9.4481 8.125 9.58333 8.125H15C15.1658 8.125 15.3247 8.19085 15.4419 8.30806C15.5592 8.42527 15.625 8.58424 15.625 8.75Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.25V4.375C5 4.20924 5.06585 4.05027 5.18306 3.93306C5.30027 3.81585 5.45924 3.75 5.625 3.75H9.16667C9.3019 3.75 9.43348 3.79386 9.54167 3.875L11.7083 5.5C11.8165 5.58114 11.9481 5.625 12.0833 5.625H17.5C17.6658 5.625 17.8247 5.69085 17.9419 5.80806C18.0592 5.92527 18.125 6.08424 18.125 6.25V13.1944C18.125 13.2674 18.1106 13.3396 18.0827 13.407C18.0548 13.4744 18.0139 13.5357 17.9623 13.5873C17.9107 13.6389 17.8494 13.6798 17.782 13.7077C17.7146 13.7356 17.6424 13.75 17.5694 13.75H15.625",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderMove);
export default __webpack_public_path__ + "static/media/folder_move.806cbbc79d149a05c6da12a341fe0f5e.svg";
export { ForwardRef as ReactComponent };